import { http } from '@/services';
import Enumerable from 'linq/linq.js';

export const riskService = {
    getRiskManagement: id => {
        let url = 'risk/management';
        if (id) url += '/' + id;

        return http.get(url).then(
            response => {
                return response.data;
            },
            error => {
                return Promise.reject(error && error.response ? error.response : error);
            }
        );
    },
    getCurrentRiskManagement: () => {
        return http.get('risk/management/current').then(
            response => {
                return response.data;
            },
            error => {
                return Promise.reject(error && error.response ? error.response : error);
            }
        );
    },
    getActiveRiskManagement: () => {
        return http.get('risk/management/active').then(
            response => {
                return response.data;
            },
            error => {
                return Promise.reject(error && error.response ? error.response : error);
            }
        );
    },
    setRiskManagement: rm => {
        return http.post('risk/management', rm).then(
            response => {
                return response.data;
            },
            error => {
                return Promise.reject(error && error.response ? error.response : error);
            }
        );
    },
    updateRiskManagement: rm => {
        return http.post('risk/management/' + rm.id, rm).then(
            response => {
                return response.data;
            },
            error => {
                return Promise.reject(error && error.response ? error.response : error);
            }
        );
    },
    getRiskMap: () => {
        return http.get('risk/map').then(
            response => {
                return response.data;
            },
            error => {
                return Promise.reject(error && error.response ? error.response : error);
            }
        );
    },
    getSafeguardsMap: () => {
        return http.get('risk/safeguards').then(
            response => {
                return response.data;
            },
            error => {
                return Promise.reject(error && error.response ? error.response : error);
            }
        );
    },
    getThreatMap: () => {
        return http.get('risk/threats').then(
            response => {
                return response.data;
            },
            error => {
                return Promise.reject(error && error.response ? error.response : error);
            }
        );
    },
    updateSafeguards: (rm, threatMap, safeguardsMap, inventoryMap) => {
        // get all safeguards for threats in risk management plan
        let safeguards = Enumerable.from(threatMap)
            .join(rm.threats,
                function(o) { return o.id + ':' + o.revision; },
                function(i) { return i.id + ':' + i.revision; },
                function(o, i) { return { id: o.id, safeguards: o.safeguards, active: i.active }; })
            .where(x => { return x.active == true }) // only active threats
            .selectMany(x => { return x.safeguards; }) // flatten out into safeguard array
            .distinct(x => { return x; }) // only return one of each safeguard
            .join(JSON.parse(JSON.stringify(safeguardsMap)),
                function(o) { return o; },
                function(i) { return i.id; },
                function(o, i) { return i; })
            .toArray();

        let seed = rm.seed; // needed for eval
        let InventoryMap = inventoryMap; // needed for eval

        // expand safeguards that have items to loop over
        for (let i = 0; i < safeguards.length; i++) {
            let sg = safeguards[i];

            if (sg.hasOwnProperty('loop')) {
                console.log('RAEval[Loop]:', sg.loop);
                let loopEval = eval(sg.loop);

                for (let obj in loopEval) {
                    let item = loopEval[obj]; // needed for eval

                    // test loop item for positive safeguard
                    console.log('RAEval[Pos]:', sg.pos);
                    if (eval(sg.pos)) {
                        if (!sg.posList) sg.posList = [];

                        console.log('RAEval[Pos List]:', sg.list);
                        sg.posList = sg.posList.concat(eval(sg.list));
                    }

                    // test loop item for negative safeguard
                    console.log('RAEval[Neg]:', sg.neg);
                    if (eval(sg.neg)) {
                        if (!sg.negList) sg.negList = [];

                        console.log('RAEval[Neg List]:', sg.list);
                        sg.negList = sg.negList.concat(eval(sg.list));
                    }
                }

                // loop property, so check pos/neg list length
                sg.posEval = sg.posList && sg.posList.length > 0;
                sg.negEval = sg.negList && sg.negList.length > 0;
            } else {
                // no loop property, so just eval pos/neg
                sg.posEval = sg.pos && eval(sg.pos);
                sg.negEval = sg.neg && eval(sg.neg);
            }

            // update risk management safeguards
            if (!rm.safeguards) rm.safeguards = {};
            if (!rm.safeguards[sg.id]) rm.safeguards[sg.id] = { implement: false, reason: '', reasonDetails: '', assignee: '', list: [], approved: false };
            rm.safeguards[sg.id].posEval = sg.posEval;
            rm.safeguards[sg.id].posList = sg.posList ? JSON.parse(JSON.stringify(sg.posList)) : null; // copy the list
            rm.safeguards[sg.id].negEval = sg.negEval;
            rm.safeguards[sg.id].negList = sg.negList ? JSON.parse(JSON.stringify(sg.negList)) : null; // copy the list

            if (sg.type == 'required') {
                rm.safeguards[sg.id].implement = true;
            }
            if (!rm.safeguards[sg.id].list || rm.safeguards[sg.id].list.length < 1) {
                rm.safeguards[sg.id].list = sg.negList ? JSON.parse(JSON.stringify(sg.negList)) : null; // copy the list
            }
        }

        return safeguards;
    }
};